import Vue from 'vue'
import Bus from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
// import Blob from '@/utils/Blob'
// import Export2Excel from '@/utils/Export2Excel'
// import '@/utils/directives.js'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme/index.css'
Vue.use(Element);

Element.Dialog.props.closeOnClickModal.default = false
import '@/styles/index.scss' // global css
// import 'iview/dist/styles/iview.css';

import App from './App'
import router from './router'
import store from './store'

import axios from 'axios' // 未拦截请求
import $axios from './utils/$axios' // 需要拦截请求
import api from './API'
import $http from './utils/http'
import VueResource from 'vue-resource';



// Vue.prototype.$http = $http;
Vue.prototype.$axios = $axios;
Vue.prototype.api = api;
Vue.prototype.$login = axios;
// import Print from './plugs/print'

// import i18n from './lang' // Internationalization
// import './icons' // icon
// import './errorLog'// error log
// import './permission' // permission control
// import './mock' // simulation data
// import { Table } from 'view-design';
// import * as filters from './filters' // global filters
import VueBus from 'vue-bus'
Vue.use(VueBus)
Vue.use(VueResource);

/* var eventBus = {
  install(Vue,options) {
      Vue.prototype.$bus = new Bus()
  }
};
Vue.use(eventBus); */
// Vue.component('Table', Table);
// register global utility filters.
/* Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
}) */

//     复制粘贴在main.js里
// 自定义指令：解决element-ui按钮重复点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

